import React from "react"
import styled from "@emotion/styled"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

import NextArrowSVG from "../../../../../assets/icons/nova/arrow-right-solid-40.svg"

const Arrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  svg {
    height: 24px;
    width: 24px;
  }

  @media (min-width: ${theme.mediaqueries.medium}) {
    svg {
      //height: 16px;
      //width: 8px;
    }
  }
`

export const NextArrow = ({ onClick }) => {
  return (
    <Arrow onClick={onClick}>
      <NextArrowSVG />
    </Arrow>
  )
}

export const PrevArrow = ({ onClick }) => {
  return (
    <Arrow onClick={onClick}>
      <NextArrowSVG />
    </Arrow>
  )
}
